import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export const Breadcrumbs = ({ items }) => {
  return (
    <nav aria-label="Breadcrumb" className="mb-6" data-testid="breadcrumbs">
      <ol className="flex items-center flex-wrap gap-2 text-sm">
        <li>
          <Link
            to="/"
            className="flex items-center gap-1 text-text-muted hover:text-brand-primary transition-colors"
            data-testid="breadcrumb-home"
          >
            <Home className="w-4 h-4" />
            <span className="sr-only">Inicio</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={item.href || index} className="flex items-center gap-2">
            <ChevronRight className="w-4 h-4 text-text-muted" />
            {item.href ? (
              <Link
                to={item.href}
                className="text-text-muted hover:text-brand-primary transition-colors"
                data-testid={`breadcrumb-${item.label.toLowerCase().replace(/\s/g, '-')}`}
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-text-primary font-medium" aria-current="page">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
